import { useMemo } from "react";
import { useCart } from "./cart.context";
import { CartItem } from "./cart-item.component";
import { CartItemPlaceholder } from "./cart-item-placeholder.component";

type CartItemsProps = {
	isLoading: boolean;
};

export function CartItems({ isLoading }: Readonly<CartItemsProps>) {
	const { pharmacyItems, remainingItemsLimit } = useCart();

	const placeholders = useMemo(
		() =>
			new Array(remainingItemsLimit).fill(null).map((_, index) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: dynamically generated placeholder list, order doesn't matter
				<CartItemPlaceholder key={index} index={pharmacyItems.length + index} />
			)),
		[pharmacyItems.length, remainingItemsLimit],
	);

	return (
		<ul className="flex flex-col notranslate" translate="no">
			{pharmacyItems.map((item, index) => (
				<CartItem
					key={item.id}
					item={item}
					index={index}
					isLoading={isLoading}
				/>
			))}

			<div className="flex flex-col px-4 md:px-6">{placeholders}</div>
		</ul>
	);
}
